import type { FC } from 'react';
import type {
  CaseStudyComponentSlotProps,
  CustomComponentProps,
} from './ComponentSlot.types';
import { MatchStats } from './PanenkaMatchStats';
import { PlayerCardGenerator } from './PlayerCardGenerator';

const components: Record<string, FC<CustomComponentProps>> = {
  PlayerCardGenerator,
  MatchStats,
};

export const CaseStudyComponentSlot = ({
  componentType,
  props,
}: CaseStudyComponentSlotProps) => {
  const Component = components[componentType];
  if (!Component) return null;
  return <Component props={props} />;
};
